import { IConnectionConfigEnvironment, IFtpConnectionTypes } from 'types/graphqlTypes'
import * as yup from 'yup'

const REQUIRED_MESSAGE = 'This field is required'

export const InboundFileRouterConfigModalSchema = yup.object({
  /**
   * @example '4'
   */
  id: yup.string(),
  /**
   * @example 'SFTP_WITH_PASSWORD'
   */
  connectionType: yup
    .mixed<IFtpConnectionTypes>()
    .oneOf([...Object.values(IFtpConnectionTypes)])
    .required(REQUIRED_MESSAGE),
  /**
   * @example true
   */
  disabled: yup.boolean().default(true).required(REQUIRED_MESSAGE),
  /**
   * @example 'production'
   */
  environment: yup
    .mixed<IConnectionConfigEnvironment>()
    .oneOf([...Object.values(IConnectionConfigEnvironment)])
    .required(REQUIRED_MESSAGE),
  /**
   * @example 'edi-file-server.transfix.io'
   */
  host: yup.string().required(REQUIRED_MESSAGE),
  /**
   * @example '22'
   */
  port: yup.number().required(REQUIRED_MESSAGE),
  /**
   * @example 'tfxh-1edi'
   */
  username: yup.string().required(REQUIRED_MESSAGE),
  /**
   * @example 'EDI_AWS_SECRET_KEY'
   */
  secretKey: yup.string().required(REQUIRED_MESSAGE),
  /**
   * @example 'PROD/FromMtd/' | 'PROD/ToMtd/'
   */
  pathPrefix: yup.string().required(REQUIRED_MESSAGE),
  /**
   * @example '{ "key": "value" }'
   */
  shipperCodeJson: yup.string().required(REQUIRED_MESSAGE),
  /**
   * @example 'ryder'
   */
  tmsName: yup.string().required(REQUIRED_MESSAGE),
})

export type TInboundFileRouterConfigModalSchema = yup.InferType<
  typeof InboundFileRouterConfigModalSchema
>
